import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'GetPromotions',
        args: {},
    });

    const response = {
        promotions: [],
        error: null,
    };

    if (result?.response?.code > 299) {
        response.error = response.message;
    } else {
        result.hasJackpot = false;
        response.promotions = result;
    }

    return response;
};
